(function () {
  var WISHLIST_KEY = 'koji_wishlist_data';

  function readWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
  }
  function updateWishlistBadges(count) {
    document.querySelectorAll('.koji-wishlist-badge, .koji-cart-badge.koji-wishlist-badge').forEach(function (badge) {
      badge.textContent = count;
      if (count > 0) {
        badge.classList.add('is-active');
        badge.style.opacity = '1';
        badge.style.transform = 'scale(1)';
      } else {
        badge.classList.remove('is-active');
        badge.style.opacity = '0';
        badge.style.transform = 'scale(0.5)';
      }
    });
  }

  function initGallery() {
    var main = document.querySelector('.ksp-main');
    if (!main) return;
    var slides = main.querySelectorAll('.ksp-slide');
    var thumbs = document.querySelectorAll('.ksp-thumb');
    var counter = document.querySelector('.ksp-counter-cur');
    function setActive(i) {
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === i);
        t.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
      if (counter) counter.textContent = i + 1;
    }
    var raf;
    main.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(main.scrollLeft / main.clientWidth);
        setActive(Math.max(0, Math.min(slides.length - 1, i)));
      });
    }, { passive: true });
    thumbs.forEach(function (t, k) {
      t.addEventListener('click', function () { main.scrollTo({ left: k * main.clientWidth, behavior: 'smooth' }); });
    });
  }

  function initQtyAndSubmit() {
    var input = document.getElementById('koji-sp-qty-input');
    var minus = document.querySelector('.ksp-qty-btn.minus');
    var plus = document.querySelector('.ksp-qty-btn.plus');
    if (input && minus && plus) {
      minus.addEventListener('click', function () { var v = parseInt(input.value, 10) || 1; if (v > 1) input.value = v - 1; });
      plus.addEventListener('click', function () { var v = parseInt(input.value, 10) || 1; if (v < 99) input.value = v + 1; });
    }
    var form = document.getElementById('koji-sp-form');
    if (form) {
      form.addEventListener('submit', function () {
        document.querySelectorAll('.ksp-add').forEach(function (btn) {
          if (btn.disabled) return;
          btn.classList.add('is-loading');
          var label = btn.querySelector('.ksp-add-text');
          var txt = btn.getAttribute('data-loading-text');
          if (label && txt) label.textContent = txt;
        });
      });
    }
  }

  function initWishlist() {
    var btn = document.querySelector('.ksp-wish');
    if (!btn) { updateWishlistBadges(readWishlist().length); return; }
    var handle = btn.getAttribute('data-product-handle');
    var data = {
      handle: handle,
      title: btn.getAttribute('data-product-title'),
      price: btn.getAttribute('data-product-price'),
      image: btn.getAttribute('data-product-image')
    };
    var list = readWishlist();
    if (list.some(function (i) { return i.handle === handle; })) btn.classList.add('is-active');
    btn.setAttribute('aria-pressed', btn.classList.contains('is-active') ? 'true' : 'false');
    updateWishlistBadges(list.length);

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var wl = readWishlist();
      var idx = wl.findIndex(function (i) { return i.handle === handle; });
      if (idx > -1) { wl.splice(idx, 1); btn.classList.remove('is-active'); }
      else { wl.push(data); btn.classList.add('is-active'); if (navigator.vibrate) navigator.vibrate([20, 50, 20]); }
      btn.setAttribute('aria-pressed', btn.classList.contains('is-active') ? 'true' : 'false');
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(wl));
      updateWishlistBadges(wl.length);
    });
  }

  function initArtist() {
    var wrap = document.querySelector('.ksp-artist-wrap');
    if (!wrap) return;
    var trigger = wrap.querySelector('.ksp-artist-trigger');
    var pop = wrap.querySelector('.ksp-artist-pop');
    var closeBtn = wrap.querySelector('.ksp-artist-close');
    function open() { pop.classList.add('is-active'); trigger.setAttribute('aria-expanded', 'true'); pop.setAttribute('aria-hidden', 'false'); }
    function close() { pop.classList.remove('is-active'); trigger.setAttribute('aria-expanded', 'false'); pop.setAttribute('aria-hidden', 'true'); }
    trigger.addEventListener('click', function (e) { e.preventDefault(); pop.classList.contains('is-active') ? close() : open(); });
    wrap.addEventListener('mouseenter', function () { if (window.innerWidth >= 990) open(); });
    wrap.addEventListener('mouseleave', function () { if (window.innerWidth >= 990) close(); });
    if (closeBtn) closeBtn.addEventListener('click', function (e) { e.preventDefault(); close(); trigger.focus(); });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('is-active')) { close(); trigger.focus(); } });
  }

  function initDescription() {
    var desc = document.querySelector('.ksp-desc');
    var more = document.querySelector('.ksp-more');
    if (!desc || !more) return;
    function check() {
      if (window.innerWidth >= 990) { more.hidden = true; return; }
      if (desc.classList.contains('is-open')) { more.hidden = false; return; }
      more.hidden = desc.scrollHeight <= desc.clientHeight + 4;
    }
    more.addEventListener('click', function () {
      var open = desc.classList.toggle('is-open');
      more.textContent = open ? 'Mostra meno' : 'Leggi tutto';
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    check();
    window.addEventListener('resize', check);
  }

  /* Barra acquisto fissa: compare solo dopo aver scrollato e quando il bottone principale non e' visibile */
  function initSticky() {
    var bar = document.querySelector('.ksp-sticky');
    var cta = document.querySelector('.ksp-actions .ksp-add');
    if (!bar || !cta || !('IntersectionObserver' in window)) return;
    var ctaVisible = false;
    function update() {
      var show = !ctaVisible && window.scrollY > 380;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    new IntersectionObserver(function (entries) {
      ctaVisible = entries[0].isIntersecting;
      update();
    }, { threshold: 0.1 }).observe(cta);
    window.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
  }

  function init() {
    initGallery(); initQtyAndSubmit(); initWishlist(); initArtist(); initDescription(); initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();